import apiClient from './api';

export const usuarioProcesoService = {
  // Listar todos los usuarios en proceso
  getAllUsuarioProcesos: async () => {
    const response = await apiClient.get('/usuario-proceso');
    return response.data;
  },

  // Obtener usuario-proceso por ID
  getUsuarioProcesoById: async (id) => {
    const response = await apiClient.get(`/usuario-proceso/${id}`);
    return response.data;
  },

  // Crear nueva asignación usuario-proceso
  createUsuarioProceso: async (usuarioProcesoData) => {
    const response = await apiClient.post('/usuario-proceso', usuarioProcesoData);
    return response.data;
  },

  // Actualizar usuario-proceso
  updateUsuarioProceso: async (id, usuarioProcesoData) => {
    const response = await apiClient.put(`/usuario-proceso/${id}`, usuarioProcesoData);
    return response.data;
  },

  // Eliminar usuario-proceso
  deleteUsuarioProceso: async (id) => {
    const response = await apiClient.delete(`/usuario-proceso/${id}`);
    return response.data;
  },

  // Obtener procesos asignados a un usuario específico
  getProcesosPorUsuario: async (usuarioId) => {
    const response = await apiClient.get(`/usuario-proceso/usuario/${usuarioId}`);
    return response.data;
  },
};

export default usuarioProcesoService;
